import React, { useState } from "react";
import logo from "../../images/home/logo.png";
import { NavLink } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="absolute top-0 left-0 w-full z-50 bg-gradient-to-b from-black/70 to-transparent md:px-10 px-4 py-5">
      <div
        style={{ maxWidth: "1440px", margin: "0 auto" }}
        className="flex justify-between items-center"
      >
        {/* Logo */}
        <div className="flex gap-2">
          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden text-white text-2xl"
          >
            {isOpen ? <FiX /> : <FiMenu />}
          </button>
          <div className="flex items-center">
            <NavLink to="/">
              <img src={logo} alt="Gir Glades" className="md:h-14 h-8" />
            </NavLink>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8">
          <NavLink
            to="/"
            className="text-white uppercase font-semibold text-base hover:text-gray-300"
          >
            Home
          </NavLink>
          <NavLink
            to="/about-us"
            className="text-white uppercase text-base hover:text-gray-300"
          >
            About Us
          </NavLink>
          <NavLink
            to="/gallery"
            className="text-white uppercase text-base hover:text-gray-300"
          >
            Gallery{" "}
          </NavLink>
          <NavLink
            to="/experience"
            className="text-white uppercase text-base hover:text-gray-300"
          >
            Experience
          </NavLink>
          {/* <div className="relative group">
            <button className="text-white text-base uppercase flex items-center">
              <NavLink
                to="/booking"
                className="text-white uppercase text-base hover:text-gray-300"
              >
                Booking
              </NavLink>
            </button>
          </div> */}
          <NavLink
            to="/contact-us"
            className="text-white uppercase text-base hover:text-gray-300"
          >
            Contact Us
          </NavLink>
        </nav>

        {/* Start Booking Button */}
        <NavLink
          to="/booking"
          className="flex text-white border border-white w-[100px] md:w-[175px] h-[32px] md:h-[40px] justify-center max-md:text-[10px] items-center rounded-full hover:bg-white hover:text-black transition"
        >
          Start Booking
        </NavLink>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden flex flex-col  items-center space-y-6 mt-5 bg-black p-5 rounded-lg">
          <NavLink
            to="/"
            className="text-white uppercase text-base"
            onClick={toggleMenu}
          >
            Home
          </NavLink>
          <NavLink
            to="/about-us"
            className="text-white uppercase text-base"
            onClick={toggleMenu}
          >
            About Us
          </NavLink>
          <NavLink
            to="/experience"
            className="text-white uppercase text-base"
            onClick={toggleMenu}
          >
            Experience
          </NavLink>
          <NavLink
            to="/booking"
            className="text-white uppercase text-base"
            onClick={toggleMenu}
          >
            Booking
          </NavLink>
          <NavLink
            to="/gallery"
            className="text-white uppercase text-base"
            onClick={toggleMenu}
          >
            Gallery{" "}
          </NavLink>
          <NavLink
            to="/contact-us"
            className="text-white uppercase text-base"
            onClick={toggleMenu}
          >
            Contact Us
          </NavLink>
        </div>
      )}
    </header>
  );
};

export default Header;
